import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getSingularReview(axiosPrivate, decisionId) {
	return axiosPrivate
		.get(`${apiURL}/decision/decision/${decisionId}/review.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
			if (res.status === 404) return undefined;
		})
		.catch((err) => {
			return err.response;
		});
}
export async function addSingularReview(axiosPrivate, decisionId, cb, data) {
	return axiosPrivate
		.post(`${apiURL}/decision/decision/${decisionId}/review.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Review - added");
				cb();
			} else {
				toast.error("Review failed to be added");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteSingularReview(axiosPrivate, cb, decisionId) {
	return axiosPrivate
		.delete(`${apiURL}/decision/decision/${decisionId}/review.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Review - deleted");
				cb();
			} else {
				toast.error("Review failed to be deleted");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function editSingularReview(axiosPrivate, decisionId, cb, data) {
	return axiosPrivate
		.put(`${apiURL}/decision/decision/${decisionId}/review.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Review - updated");
				cb();
			} else {
				toast.error("Review failed to update");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getAnnualReview(axiosPrivate, decisionId) {
	return axiosPrivate
		.get(`${apiURL}/decision/decision/${decisionId}/annual-review.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
			if (res.status === 404) return undefined;
		})
		.catch((err) => {
			console.log(err.response);
			return err.response;
		});
}
export async function addAnnualReview(axiosPrivate, decisionId, cb, data) {
	return axiosPrivate
		.post(`${apiURL}/decision/decision/${decisionId}/annual-review.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Review - added");
				cb();
			} else {
				toast.error("Review failed to be added");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteAnnualReview(axiosPrivate, cb, decisionId) {
	return axiosPrivate
		.delete(`${apiURL}/decision/decision/${decisionId}/annual-review.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Review - deleted");
				cb();
			} else {
				toast.error("Review failed to be deleted");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function editAnnualReview(axiosPrivate, decisionId, cb, data) {
	return axiosPrivate
		.put(`${apiURL}/decision/decision/${decisionId}/annual-review.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Review - updated");
				cb();
			} else {
				toast.error("Review failed to update");
			}
		})
		.catch((err) => {
			return err.response;
		});
}
